<template>
    <div class="product-container pt-3 mx-auto">
            <div class="col-md col container-body">
                <section>                    
                    <div class="template-body tab-bg pt-3">
                        <div class="row">
                            <div class=" h4 col-7 col-md-7 pt-3 pb-4 text-uppercase" >
                                Products
                            </div>
                            <div class=" col-5 col-md-5 pt-2 pb-2 text-uppercase" >
                                <button type="button" class="btn btn-default text-right text-uppercase font-weight-bold pr-1" @click="$router.push('/admin/product/1')">
                                    <fa-icon :icon="['fas','plus']"/> Add new 
                                </button>
                            </div>
                        </div>
                        <div class="table-responsive">
                            <table class="table border pt-5 text-uppercase">
                                <tbody  >
                                    <tr>
                                    <th>S NO</th>
                                    <th>Brand</th>
                                    <th>Product</th>
                                    <th>Edit</th>
                                    <th>Delete</th>
                                    <th>Status</th>
                                    </tr>
                                </tbody>
                                <tbody >
                                    <tr  v-for="(product,index) in productList" :key="index">
                                    <td >{{index+1}} </td>
                                    <td>{{product.brand_name}}</td>
                                    <td>{{product.product_name}}</td>
                                    <td>
                                        <button type="button" class="btn btn-default">
                                            <span class="glyphicon glyphicon-plus" @click="editProduct(product.product_id)">
                                                <fa-icon :icon="['fas','pencil-alt']"/> 
                                            </span>
                                        </button>
                                    </td>
                                    <td>
                                        <button type="button" class="btn btn-default"
                                            @click="isDeleteProduct(product.product_id)">
                                            <span class="glyphicon glyphicon-plus" >
                                                <fa-icon :icon="['fas','trash-alt']"/> 
                                            </span>
                                        </button>
                                    </td>
                                    <td>
                                        <toggle-button v-model="product.active_status" :value="product.active_status" class=" pt-1"
                                        :color ="{checked: '#007bff', unchecked: '#858585'}"
                                        @change="updateProductStatus(product.product_id,product.active_status)"/>
                                    </td>
                                    </tr>
                                
                                </tbody>
                                
                            </table>
                        </div>
                        <span id="delete-product-pop-over" data-toggle="modal" data-target="#isdeleteProduct"></span>
                        <div class="modal fade" id="isdeleteProduct" role="dialog">
                                <div class="modal-dialog modal-md">
                                    <div class="modal-content">
                                        <div class="modal-header">
                                            <button type="button" class="close" data-dismiss="modal">&times;</button>
                                            <h4 class="modal-title">Delete Product</h4>
                                        </div>
                                        <div class="modal-body">
                                            <p class="body-text"> Do you confirm to Delete the Product?</p>
                                        </div>
                                        <div class="modal-footer">
                                            <button type="button" class="btn btn-default border"  data-dismiss="modal">No</button>
                                            <button type="button" class="btn btn-primary" @click="DeleteProduct()" data-dismiss="modal">YES</button>
                                        </div>
                                    </div>
                                </div>
                        </div>
                    </div>
               </section>
            </div> 
    </div>
</template>

<script lang="ts">
    import Vue from 'vue'
    import VueToast from 'vue-toast-notification';
    import * as $ from 'jquery';

    import 'vue-toast-notification/dist/theme-default.css';

    import ProductService from '../../shared/services/product.service';

    Vue.use(VueToast)   
 

    const productService = new ProductService();


    export default Vue.extend ({ 
        
    components : {

    },
         data() {
            return {
                toast:Vue.$toast,
                productListdata:{},
                activeProductForm:{},
                isDeleteId:null,
                activeStatusText:String,
                activeProductId:Number,
                activeProductStatus:String,
                headerOptions: {
                    createProduct:'false',
                    createCategory:'true',
                    createSubcategory:'true',
                    createBrand:'true'
                },
                productlistflag:false,
            }
        },
        props:{
            productList:Object,
            mc_id:Number,
            sc_id:Number
        },
        methods: {
            updateProductStatus(productId,activeFlag){
             
                 let obj = {};

                obj['product_id'] = productId;
                obj['active_status'] = (activeFlag)? 1 : 0;

                this.activeStatusText = (activeFlag)? 'Active' : 'Inactive';
              
                productService.activeProduct(obj)
                .then(response => {
                    console.log(response)
                   this.toast.success("The product is now " +this.activeStatusText,{
                        position:'top-right'
                    })
                })
                .catch(e => {
                    this.toast.error("Product ID or status is invalid",{
                        position:'top-right'
                    })  
                    this.errors.push(e)
                }) 
            },

            editProduct(id){
                let prodid = id;
                this.$router.push({path:'/admin/product/edit/'+prodid})
            },

            isDeleteProduct(id){
                $('#delete-product-pop-over').trigger('click')
                this.isDeleteId = id
            },

            DeleteProduct(){
                let obj = {product_id:this.isDeleteId}
                productService.deleteProduct(obj)
                .then(response => {       
                    console.log(response)             
                   this.toast.success("The Product is Succesfully Deleted",{
                        position:'top-right'
                    })
                    this.isDeleteId = null
                    this.getProducts()
                })
                .catch(e => {
                    this.toast.error("Product is not valid",{
                        position:'top-right'
                    })  
                    this.errors.push(e)
                })
            },
            getProducts(){
                productService.getProductAdminList(this.mc_id,this.sc_id)
                .then(response => {
                    this.productList = response.data.output.success[0].data.list;
                })
                .catch(e => {
                this.errors.push(e)
                })  
            }
        },
         created() {
            
        }   
    })
</script>

<style  scoped>

@import '../../style.css';


.header-bg-image{
       height: 400px !important;
}

.container-body{
    padding-right:0px;
    font-family: 'Barlow', sans-serif;
}
table tbody+tbody {
        border-top: 0px solid #dee2e6;
}

</style>